import React from 'react';
import RevenueChart from './RevenueChart';
import CustomerChart from './CustomerChart';
import PieChartCard from './PieChartCard';

interface PieChartData {
  name: string;
  value: number;
  color: string;
}

interface ChartsSectionProps {
  loading?: boolean;
  data?: {
    revenueChart?: any[];
    customerChart?: any[];
    pieCharts?: {
      clientStatus?: PieChartData[];
      deviceStatus?: PieChartData[];
      mediaType?: PieChartData[];
      planDistribution?: PieChartData[];
    };
  };
}

const ChartsSection: React.FC<ChartsSectionProps> = ({ loading, data }) => {
  return (
    <section className="mb-10 space-y-8">
      {/* Gráficos de Linha */}
      <div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Evolução ao Longo do Tempo</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <RevenueChart loading={loading} data={data?.revenueChart} />
          <CustomerChart loading={loading} data={data?.customerChart} />
        </div>
      </div>

      {/* Gráficos de Pizza */}
      <div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Distribuição e Proporções</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <PieChartCard
            title="Status dos Clientes"
            data={data?.pieCharts?.clientStatus || []}
            loading={loading}
          />
          <PieChartCard
            title="Status dos Dispositivos"
            data={data?.pieCharts?.deviceStatus || []}
            loading={loading}
          />
          <PieChartCard
            title="Tipo de Mídia"
            data={data?.pieCharts?.mediaType || []}
            loading={loading}
          />
          <PieChartCard
            title="Distribuição de Planos"
            data={data?.pieCharts?.planDistribution || []}
            loading={loading}
          />
        </div>
      </div>
    </section>
  );
};

export default ChartsSection;